import React , {useEffect} from "react";
import "./LevelWisePerformance.scss";
import completedicon from "../../../../../../../Assets/AppComponent/Customersupport_icon/Levelcompletedicon.svg"
import Pendingicon from "../../../../../../../Assets/AppComponent/Customersupport_icon/Levelcompleted.svg"
import {settheInternalescalationActions} from "../../../../../../../Redux/Slice"
import { useDispatch, useSelector } from "react-redux";


export default function LevelWisePerformance({
  datas,
  PriorityValues,
  SttausValues,
  Client,
  range,
  date,
  Client_id
}) {
const dispatch = useDispatch()
const state = useSelector((state)=>state);
let isValidRange =
  Array.isArray(range) &&
  range.length > 0 &&
  range.every((date) => !!date && date !== "NaN-aN-aN");


    useEffect(()=>{
            if(state.ClientBranchIDs.SUBROLE == 3){

    const payload ={
    // state:datas?.state,
    // region:datas?.region,
    // zone:datas?.zone,
     priority:PriorityValues,
     department:Client,
           from_date: range[0],
      to_date: range[1],
      range: isValidRange,
date:date,
                  //  client:Client_id


                }
    dispatch(settheInternalescalationActions(payload))
              }
    },[Client  ,PriorityValues ,range,date ])
  const responseData = state.internalEscalationsdashboard.Escalation_dashboard_?.closed_data
  const responseDataOpen = state.internalEscalationsdashboard.Escalation_dashboard_?.opened_data



 const levels = [
  {
    level: "L1",
    completed: responseData?.L1_closed_count || 0,
    pending: responseDataOpen?.L1_opened_count || 0,
  },
  {
    level: "L2",
    completed: responseData?.L2_closed_count || 0,
    pending: responseDataOpen?.L2_opened_count || 0,
  },
  {
    level: "L3",
    completed: responseData?.L3_closed_count || 0,
    pending: responseDataOpen?.L3_opened_count || 0,
  },
];
    
console.log(levels ,"sadiopsd levels");

  return (
    <div className="level-wise-performance">
<div className="Level_wiseheader">
        <h4>Level-wise Performance</h4>

</div>
  {levels.map(({ level, completed, pending }) => {
  const total = completed + pending;
  const completedPercent = total === 0 ? 0 : (completed / total) * 100;
  const pendingPercent = total === 0 ? 0 : 100 - completedPercent;

  return (
    <div className="level-row" key={level}>
      <div className="level-tag">{level}</div>
      <div className="rightside_content">
        <div className="progress-bar">
          <div
            className="completed"
            style={{ width: `${completedPercent}%` }}
          ></div>
          <div
            className="pending"
            style={{ width: `${pendingPercent}%` }}
          ></div>
        </div>
        <div className="status-row">
          <span className="completed-label">
            <span>
              <img src={completedicon} />
            </span>
            Completed {completed} tickets
          </span>
          <span className="pending-label">
            <span>
              <img src={Pendingicon} />
            </span>
            Pending {pending} tickets
          </span>
        </div>
      </div>
    </div>
  );
})}

    </div>
  );
}
